import styled from "styled-components";

const View = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export { View };
